// @ts-nocheck
(function () {
    "use strict";

    const SECTION_SELECTOR = ".interactive-image-product-links[data-section-id]";
    const MOBILE_MAX = 749;

    function debounce(fn, delay) {
        var timer;
        return function () {
            clearTimeout(timer);
            var args = arguments;
            var ctx = this;
            timer = setTimeout(function () {
                fn.apply(ctx, args);
            }, delay);
        };
    }

    function isMobileViewport() {
        return window.innerWidth <= MOBILE_MAX;
    }

    class InteractiveImageProductLinksSection {
        constructor(root) {
            this.root = root;
            this.id = root.getAttribute("data-section-id");
            this.hotspotWrappers = Array.from(
                root.querySelectorAll("[data-hotspot-wrapper]")
            );
            this.visibilityMode =
                this.root.getAttribute("data-visibility-mode") || "both";
            this.respectReduced =
                this.root.getAttribute("data-respect-reduced-motion") ===
                "true";
            this.resizeHandler = debounce(this.handleResize.bind(this), 150);
            this.modeClassSync();
            this.init();
        }

        init() {
            window.addEventListener("resize", this.resizeHandler, {
                passive: true,
            });
            this.applyReducedMotionClass();
            this.positionAll();
        }

        destroy() {
            window.removeEventListener("resize", this.resizeHandler);
            this.hotspotWrappers = [];
        }

        modeClassSync() {
            this.root.classList.toggle("is-mobile", isMobileViewport());
            this.root.classList.toggle("is-desktop", !isMobileViewport());
        }

        applyReducedMotionClass() {
            if (!this.respectReduced) return;
            const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
            if (mq.matches) {
                this.root.classList.add(
                    "interactive-image-product-links--reduced-motion"
                );
            }
        }

        handleResize() {
            this.modeClassSync();
            this.positionAll();
        }

        ensureVisibilityByMode() {
            const viewportIsMobile = isMobileViewport();
            let hidden = false;

            if (this.visibilityMode === "desktop_only" && viewportIsMobile) {
                hidden = true;
            }

            if (this.visibilityMode === "mobile_only" && !viewportIsMobile) {
                hidden = true;
            }

            this.root.setAttribute("aria-hidden", hidden ? "true" : "false");
        }

        positionAll() {
            const mobile = isMobileViewport();
            this.ensureVisibilityByMode();

            window.requestAnimationFrame(() => {
                this.hotspotWrappers.forEach((wrapper) => {
                    this.updateWrapperPosition(wrapper, mobile);
                });
            });
        }

        updateWrapperPosition(wrapper, mobile) {
            const desktopX = parseFloat(
                wrapper.getAttribute("data-desktop-x") || "50"
            );
            const desktopY = parseFloat(
                wrapper.getAttribute("data-desktop-y") || "50"
            );
            const mobileX = parseFloat(
                wrapper.getAttribute("data-mobile-x") || String(desktopX)
            );
            const mobileY = parseFloat(
                wrapper.getAttribute("data-mobile-y") || String(desktopY)
            );
            const visibleDesktop =
                wrapper.getAttribute("data-visible-desktop") === "true";
            const visibleMobile =
                wrapper.getAttribute("data-visible-mobile") === "true";

            const x = mobile ? mobileX : desktopX;
            const y = mobile ? mobileY : desktopY;
            const safeX = isFinite(x) ? Math.min(100, Math.max(0, x)) : 50;
            const safeY = isFinite(y) ? Math.min(100, Math.max(0, y)) : 50;

            wrapper.style.setProperty("--x", String(safeX));
            wrapper.style.setProperty("--y", String(safeY));

            let hide = false;
            if (mobile && !visibleMobile) hide = true;
            if (!mobile && !visibleDesktop) hide = true;
            wrapper.classList.toggle("is-hidden", hide);
        }

        selectBlock(blockId) {
            const target = this.hotspotWrappers.find(
                (wrapper) => wrapper.getAttribute("data-block-id") === blockId
            );
            if (!target) return;

            this.hotspotWrappers.forEach((wrapper) => {
                wrapper.classList.remove("is-selected");
            });
            target.classList.add("is-selected");

            setTimeout(() => {
                try {
                    target.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                        inline: "center",
                    });
                } catch (_) {}
            }, 50);
        }

        deselectBlock(blockId) {
            const target = this.hotspotWrappers.find(
                (wrapper) => wrapper.getAttribute("data-block-id") === blockId
            );
            if (target) {
                target.classList.remove("is-selected");
            }
        }
    }

    const instances = new Map();

    function initAll() {
        document.querySelectorAll(SECTION_SELECTOR).forEach((section) => {
            const id = section.getAttribute("data-section-id");
            if (!instances.has(id)) {
                instances.set(id, new InteractiveImageProductLinksSection(section));
            }
        });
    }

    function destroySection(sectionId) {
        const instance = instances.get(sectionId);
        if (instance) {
            instance.destroy();
            instances.delete(sectionId);
        }
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initAll);
    } else {
        initAll();
    }

    document.addEventListener("shopify:section:load", (e) => {
        const target = e.target;
        if (!(target instanceof HTMLElement)) return;

        const section = target.matches(SECTION_SELECTOR)
            ? target
            : target.querySelector(SECTION_SELECTOR);

        if (section instanceof HTMLElement) {
            const id = section.getAttribute("data-section-id");
            if (!id) return;
            destroySection(id);
            instances.set(id, new InteractiveImageProductLinksSection(section));
        }
    });

    document.addEventListener("shopify:section:unload", (e) => {
        const target = e.target;
        if (!(target instanceof HTMLElement)) return;

        const section = target.matches(SECTION_SELECTOR)
            ? target
            : target.querySelector(SECTION_SELECTOR);

        if (section instanceof HTMLElement) {
            const id = section.getAttribute("data-section-id");
            if (!id) return;
            destroySection(id);
        }
    });

    document.addEventListener("shopify:block:select", (e) => {
        const evt =
            /** @type {CustomEvent & { detail?: { blockId?: string } }} */ (e);
        const blockId = evt.detail && evt.detail.blockId;
        if (!blockId) return;

        document.querySelectorAll(SECTION_SELECTOR).forEach((sec) => {
            const id = sec.getAttribute("data-section-id");
            const inst = instances.get(id);
            if (inst) inst.selectBlock(blockId);
        });
    });

    document.addEventListener("shopify:block:deselect", (e) => {
        const evt =
            /** @type {CustomEvent & { detail?: { blockId?: string } }} */ (e);
        const blockId = evt.detail && evt.detail.blockId;
        if (!blockId) return;

        document.querySelectorAll(SECTION_SELECTOR).forEach((sec) => {
            const id = sec.getAttribute("data-section-id");
            const inst = instances.get(id);
            if (inst) inst.deselectBlock(blockId);
        });
    });
})();